import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

export function carregarDash(data) {
    return {
        type: 'DASHBOARD_FETCHED',
        payload: data
    }
}

export function getDashboard(values) {
    const { idNegocio, ano, mes } = values;
    
    return dispatch => {
        dispatch({ type: 'DASHBOARD_LOADING', payload: true });
        axios.get(`${URL}/dashboard/${idNegocio}/${ano}/${mes}`)
            .then(resp => {
                dispatch(carregarDash(resp.data))
                dispatch({ type: 'DASHBOARD_LOADING', payload: false });
            })
            .catch(e => {
                toastr.error('Erro', e.message)
                dispatch({ type: 'DASHBOARD_LOADING', payload: false });
            })
    }
}